import Vue from 'vue';
import VueI18n from 'vue-i18n';
import catalog from './messages';

Vue.use(VueI18n);

const LOCALE_KEY = 'crowd_locale';
const supportedLocales = catalog.localeOptions.map((item) => item.value);

export function getStoredLocale() {
  const stored = localStorage.getItem(LOCALE_KEY);
  return supportedLocales.includes(stored) ? stored : 'en';
}

export function setStoredLocale(locale) {
  if (supportedLocales.includes(locale)) {
    localStorage.setItem(LOCALE_KEY, locale);
  }
}

const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: catalog.messages
});

export const localeOptions = catalog.localeOptions;
export default i18n;
